import { graphql } from '@/__generated__';
import { useCacheMonitor } from '@/context/DiscoveryUrqlProvider';
import { useQueryStable } from '../useQueryStable';
import { GetDefinitionNode } from './testUtil';

type Result = ReturnType<typeof useGroupByEnvironment>[0];

export type GroupResponse = NonNullable<Result['data']>;

export type RequestedGroupDefinitionNode = GetDefinitionNode<'groups', GroupResponse>;

// https://github.com/dbt-labs/codex-api/blob/main/schema.graphql
// https://github.com/dbt-labs/codex-api/blob/main/frontend/package.json#L33
// https://github.com/dbt-labs/codex-api/blob/main/frontend/codegen.yml
// generates: https://github.com/dbt-labs/codex-api/blob/main/frontend/src/typings/codex.ts
export const GetGroupByUniqueId = graphql(/* GraphQL */ `
  query Group($environmentId: BigInt!, $userId: BigInt, $uniqueId: String!) {
    environment(id: $environmentId, userId: $userId) {
      definition {
        lastUpdatedAt
        groups(first: 1, filter: { uniqueIds: [$uniqueId] }) {
          edges {
            node {
              name
              uniqueId
              projectId
              models {
                name
                uniqueId
                contractEnforced
                database
                schema
              }
              ownerName
              ownerEmail
              ownerSlack
              ownerGithub
              meta
              description
              tags
            }
          }
        }
      }
    }
  }
`);

type GroupByEnvironmentParams = {
  environmentId: number | undefined;
  userId?: number | 'loading' | null;
  uniqueId: string | undefined;
  pause?: boolean;
};

/**
 * Groups are Definition Only
 */
export const useGroupByEnvironment = ({
  environmentId = 0,
  userId,
  uniqueId,
  pause,
}: GroupByEnvironmentParams) => {
  const query = useQueryStable({
    query: GetGroupByUniqueId,
    variables: { environmentId, userId: userId as number | null, uniqueId: uniqueId! },
    pause: pause || !environmentId || !uniqueId || userId === 'loading',
  });

  useCacheMonitor({ definition: query[0].data?.environment.definition?.lastUpdatedAt });

  return query;
};
